(() => {
  function parsePresaleUnix(value) {
    const normalized = String(value ?? '').trim();
    if (!/^\d+$/.test(normalized)) return null;
    const parsed = Number.parseInt(normalized, 10);
    return Number.isSafeInteger(parsed) ? parsed : null;
  }

  function resolveNowUnix(value) {
    const parsed = parsePresaleUnix(value);
    if (Number.isSafeInteger(parsed)) return parsed;
    return Math.floor(Date.now() / 1000);
  }

  function getPresaleState({ saleStartUnix, nowUnix } = {}) {
    const normalizedSaleStartUnix = parsePresaleUnix(saleStartUnix);
    if (!Number.isSafeInteger(normalizedSaleStartUnix)) {
      return {
        hasSaleStart: false,
        saleStartUnix: null,
        isLocked: false,
      };
    }

    return {
      hasSaleStart: true,
      saleStartUnix: normalizedSaleStartUnix,
      isLocked: normalizedSaleStartUnix > resolveNowUnix(nowUnix),
    };
  }

  function getPresaleCountdownState({ saleStartUnix, nowMs } = {}) {
    const presaleState = getPresaleState({ saleStartUnix });
    if (!presaleState.hasSaleStart) {
      return {
        hasSaleStart: false,
        saleStartMs: null,
        diffMs: 0,
        isLocked: false,
      };
    }

    const saleStartMs = presaleState.saleStartUnix * 1000;
    const currentMs = Number.isFinite(nowMs) ? nowMs : Date.now();
    const diffMs = saleStartMs - currentMs;

    return {
      hasSaleStart: true,
      saleStartMs,
      diffMs,
      isLocked: diffMs > 0,
    };
  }

  function padPresaleNumber(value) {
    return value < 10 ? `0${value}` : String(value);
  }

  function formatPresaleRemaining(diffMs) {
    const safeMs = Math.max(Number(diffMs) || 0, 0);
    const totalSec = Math.floor(safeMs / 1000);
    const days = Math.floor(totalSec / 86400);
    const hours = Math.floor((totalSec % 86400) / 3600);
    const mins = Math.floor((totalSec % 3600) / 60);
    const secs = totalSec % 60;

    if (days > 0) {
      return `${days}日 ${padPresaleNumber(hours)}:${padPresaleNumber(mins)}:${padPresaleNumber(secs)}`;
    }
    return `${padPresaleNumber(hours)}:${padPresaleNumber(mins)}:${padPresaleNumber(secs)}`;
  }

  const api = {
    parsePresaleUnix,
    getPresaleState,
    getPresaleCountdownState,
    formatPresaleRemaining,
  };

  if (typeof window !== 'undefined') {
    window.MFPresaleHelpers = Object.assign({}, window.MFPresaleHelpers || {}, api);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
})();
